module.exports = __webpack_public_path__ + "static/media/Golf-Ridge-Villas-Bylaws.8a2f5dba.pdf";